import React, { useState, useEffect } from "react";
import "./ExploreCollections.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Scrollbars } from "react-custom-scrollbars";
import axios from "axios";
import services, { baseUrl } from "../../Common/services.jsx";
import Api from "../../Common/api.jsx";
import { Navigate, Link } from "react-router-dom";
import SkeletonProduct  from "../../Pages/Skeleton/index.jsx";

export default class ExploreCollections extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.timeout1 = 0;
    this.pageNumber = 1;
    this.state = {
      filter: "",
      loader : false,
      loader1 : false,
      SkelatonLoader:false,
      setFilter: "",
      redirect: null,
      exploreArray: [],
      categoryArray: [],
      featureNftArray: [],
      category_id: null,
      showVerifiedOnly: false,
      status: false,
      minprice: "", //null,
      maxPrice: "", //null,
      chain: [],
      // pageNumber: 1,
      pageSize: 20,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      console.log("in1");
     // document.getElementsByClassName("search-autocomplete")[0].style.display ="none";
    });
    this.getExploreNft(null);
    this.getPredefineCategory();
    this.getNftCollection();
  }

  redirectCollection(id, flag) {
    console.log(id);
    if (flag == 1) {
      this.setState({ redirect: "../CollectionDetails/?collectionId=" + id });
    } else if (flag == 2) {
      this.setState({ redirect: "../NftDetails/?assetId=" + id });
    }
  }

  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  handleChangeCheck = (e) => {
    this.setState({ status: e.target.checked });
    console.log(e.target.checked);
  };

  setFilterData(e) {
    this.setState({ showVerifiedOnly: e.target.checked });
  }
  setFilterCategoryData(id) {
    this.setState({ category_id: id });
    this.setState({ category_id: id }, () => {
      this.pageNumber = 1;
      console.log(this.state.category_id, "category_id");
      this.getExploreNft();
    });
  }

  array = [];
  setChainData(e) {
    console.log(e.target.checked);
    if (e.target.checked) {
      this.array.push(e.target.name);
      this.setState({ chain: this.array });
    } else {
      this.array = this.array.filter(function (value, index, arr) {
        return value != e.target.name;
      });

      this.setState({ chain: this.array });
    }
    console.log(this.state.chain);
  }

  searchAssets(id) {
    this.setState({ category_id: id, assets: [], totalRecords: 0 }, () => {
      console.log(this.state.category_id, "category_id");
      this.getExploreNft();
      this.explorrerCollectionClose(1);
    });
   
  }

  getExploreNft(categoryName) {
    const api = new Api();
    this.setState({loader: true});
    const obj = {
      minprice: this.state.minprice,
      maxPrice: this.state.maxPrice,
      chain: this.state.chain,
      category_id: this.state.category_id,
      showVerifiedOnly: this.state.showVerifiedOnly,
      pagenumber: this.pageNumber,
      pagesize: this.state.pageSize,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: obj,
    };

    api
      .post("filtered_collections/", obj)
      .then((response) => {
        if (this.pageNumber == 1) {
          this.setState({ exploreArray: response.data.collections });
          this.setState({loader: false});
        } else {
          this.setState({
            exploreArray: this.state.exploreArray.concat(
              response.data.collections
            ),
          });
          this.setState({loader: false});
        }

        //const vari=this.state.exploreArray.push(response.data)
        // this.setState({ exploreArray: [...this.state.exploreArray, 'new value'] })
        //this.setState({ exploreArray: response.data });
        console.log(this.state.exploreArray);

      })
      .catch((err) => console.log(err));
      this.applyFilter = true;
    //this.explorrerCollectionClose();
  }

  showMore() {
    console.log(this.pageNumber);
    //this.setState({SkelatonLoader:true});

    //this.timeout1 = setTimeout(() => {

    this.pageNumber = this.pageNumber + 1;
    this.getExploreNft();
    this.state.pageSize = 26;
   
    //clearTimeout(this.timeout1);
    
   //}, 1000);
  }

  setFilterData1(key, value) {
    this.setState({ key: value });
    if (key == "category_id") {
      this.getExploreNft();
    }
  }

  getPredefineCategory() {
    const api = new Api();
    var parameter = "";
    api
      .get("get_categories/", parameter)
      .then((response) => {
        this.setState({ categoryArray: response.data });
      })
      .catch((err) => console.log(err));
  }

  getNftCollection() {
    const api = new Api();
    this.setState({loader1: true});
    var parameter = "";

   // this.timeout = setTimeout(() => {
    api
      .get("get_featured_nft_collection/?pagesize=10&pagenumber=1", parameter)
      .then((response) => {
        this.setState({ featureNftArray: response.data });
        this.setState({loader1: false});
      //  clearTimeout(this.timeout);
      })
      .catch((err) => console.log(err));
   //}, 10000);
  }

  explorrerCollection() {
    document.body.classList.toggle("filterActive", "filter");
    document
      .querySelector(".btn-show-filtetr")
      .classList.toggle("active", "filter");
    document
      .querySelector(".filter-sidebar")
      .classList.toggle("filter-open", "filter");
  }
  async clearAll() {
    this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
    this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
    this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
    this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;

    this.applyFilter = false;
    this.array=[]
    await this.setState({chain: []});
   await this.setState(
      {
        status: false,
        minprice: "",
        maxPrice: "",
        chain: [],
        category_id: null,
        showVerifiedOnly: false,
        isInvalidUser: false,
        assets: [],
        totalRecords: 0,
      },
      () => {
        this.getExploreNft();
        console.log("clear");
      }
    );
    console.log(this.state.chain);
  }
 

  explorrerCollectionClose(flag) {
    document.body.classList.toggle("filter", "filterActive");
    document
      .querySelector(".btn-show-filtetr")
      .classList.toggle("filter", "active");
    document
      .querySelector(".filter-sidebar")
      .classList.remove("filter-open");
    if (flag == 2) {
      //var x = document.getElementsByClassName("verifiedCheck");
      //this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
      this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
      this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
      this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;
      //x.checked = false;
      this.array=[]
      this.applyFilter = false;
      this.setState(
        {
          status: false,
          minprice: "",
          maxPrice: "",
          chain: [],
          category_id: null,
          assets: [],
          totalRecords: 0,
        },
        () => {
          this.getExploreNft();
          console.log("clear");
        }
      );
    }
  }

  removeChain(flag) {
    console.log(this.state.chain[flag]);
    this.refs[this.state.chain[flag]].checked = false;
    var name = this.state.chain[flag];
    this.array = this.array.filter(function (value, index, arr) {
      return value != name;
    });
    this.setState({ chain: this.array });
  }
  // removeShowOnly() {
  //   this.refs["verifiedCheck"].checked = false;
  //   this.setState(
  //     {
  //       showVerifiedOnly: false,
  //     },
  //     console.log("clear")
  //   );
  // }
  removePrice() {
    this.setState(
      {
        minprice: "",
        maxPrice: "",
      },
      console.log("clear")
    );
  }

  render = () => {
    if (this.state.redirect) {
      var url = this.state.redirect;
      this.setState({ redirect: null });
      return (
        <Navigate
          // to={"../SearchResult/?tab=Asset&search=" + this.state.value}
          to={url}
          replace={true}
        />
      );
    }
    return (
      <>
        <Header />
        <div className="main-container">
          <div className="container">
            <div className="section-title">
              <h2>Explore Collections</h2>
            </div>
            <div className="filter-wrap">
              <div className="filter-wrap__aside full-width">
                <button href="#" onClick={() => this.explorrerCollection()} className="button btn-show-filtetr"><i class="material-icons-outlined">filter_list</i> Show Filters</button>
                {/* <Scrollbars className="custmScrollbar scrollbar-horizontal" > */}
                <div className="filter-wrap__right">
                  <ul className="filter-list">
                    <li>
                      <a
                        className={this.state.category_id == null ? "active" : ""}
                        onClick={() => this.setFilterCategoryData(null)}
                      >
                        All Categories
                      </a>
                    </li>
                    {this.state.categoryArray.map((data, index) => (
                      <li key={index}>
                        <a
                          className={
                            this.state.category_id == data.id ? "active" : ""
                          }
                          onClick={() => this.setFilterCategoryData(data.id)}
                        >
                          {data.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                  {/* </Scrollbars> */}
                  <div className="filter-wrap__btns right">
                    <button className="btb-sort"  >
                      <div className="img-box">
                        <i className="material-icons-outlined"> notes</i>
                      </div>
                      <span>Sort</span> 
                    </button> 
                  </div> 
                </div>
              </div>
            </div>
            <div className="filter-sidebar">
              <Scrollbars className="custmScrollbar scrollbar-horizontal" >
                <div className="filter-list-box-wrap">
                  <div className="filter-box">
                    <div className="filter-title">
                      <h4>Applied Filters</h4>
                      <button className="clear-filter" onClick={() => this.clearAll()}>Clear All</button>
                    </div>
                    <ul className="applied-filter">
                      <li
                      style={{
                        display:
                          this.applyFilter &&
                          this.state.minprice != null &&
                          this.state.minprice != "" &&
                          this.state.maxPrice != null &&
                          this.state.maxPrice != ""
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span> {this.state.minprice} To {this.state.maxPrice}</span>
                        <a onClick={() => this.removePrice()}>
                          <img
                           onClick={() => this.removePrice()}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                       style={{
                        display:
                          this.applyFilter && this.state.chain[0]
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span>{this.state.chain[0]}</span>
                        <a onClick={() => this.removeChain(0)}>
                          <img
                           onClick={() => this.removeChain(0)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                        style={{
                          display:
                            this.applyFilter && this.state.chain[1]
                              ? "inherit"
                              : "none",
                        }}
                      >
                        <span>{this.state.chain[1]}</span>
                        <a onClick={(e) => this.removeChain(1)}>
                          <img
                            onClick={(e) => this.removeChain(1)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                      style={{
                        display:
                          this.applyFilter && this.state.chain[2]
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span>{this.state.chain[2]}</span>
                        <a onClick={() => this.removeChain(2)}>
                          <img
                            onClick={() => this.removeChain(2)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                    </ul>
                    {/* <div className="filter-title">
                      <h4>Status</h4>
                    </div> */}
                    {/* <ul className="filter-check-list">
                      <li>
                        <label htmlFor="buyNow">
                          <input
                            type="checkbox"
                            id="buyNow" 
                            hidden
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>Buy Now</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="onAuction">
                          <input
                            type="checkbox"
                            id="onAuction"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>On Auction</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="new">
                          <input
                            type="checkbox"
                            id="new"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>New</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="hasOffer">
                          <input
                            type="checkbox"
                            id="hasOffer"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>Has Offer</span>
                        </label>
                      </li>
                    </ul> */}
                    <div className="filter-title">
                      <h4>Price (in ETH)</h4>
                    </div>
                    <div className="price-range">
                      <input
                        type="text"
                        name="minprice"
                        id="min"
                        placeholder="min"
                        className="min"
                        value={this.state.minprice}
                          onChange={(e) => {
                            this.handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value,
                              },
                            });
                          }}
                      />
                      <span>to</span>
                      <input
                        type="text"
                        name="maxPrice"
                        id="max"
                        placeholder="max"
                        className="max"
                        value={this.state.maxPrice}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    <div className="filter-title">
                      <h4>Blockchains</h4>
                    </div>
                    <ul className="filter-check-list">
                      <li>
                        <label htmlFor="ethereum">
                          <input
                            type="checkbox"
                            id="ethereum"
                            hidden
                            //defaultChecked
                            ref="Ethereum"
                            name="Ethereum"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/eth.png" alt="Verify" />
                          </div> Ethereum</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="polygon">
                          <input
                            type="checkbox"
                            id="polygon"
                            hidden
                            //defaultChecked
                            ref="Polygon"
                            name="Polygon"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/poly.png" alt="Verify" />
                          </div> Polygon</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="solana">
                          <input
                            type="checkbox"
                            id="solana"
                            hidden
                            //defaultChecked
                            ref="Solana"
                            name="Solana"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/sola.png" alt="Verify" />
                          </div>Solana</span>
                        </label>
                      </li>
                    </ul>
                    <div className="filter-title">
                      <h4>Verification</h4>
                    </div>
                    <ul className="filter-check-list">
                      <li>
                        <label htmlFor="verified">
                          <input
                            type="checkbox"
                            id="verified"
                            ref="verifiedCheck"
                            hidden
                            onChange={(e) => this.setFilterData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/verify.png" alt="Verify" />
                          </div> Show only verified</span>
                        </label>
                      </li>
                    </ul>
                    <div className="filter-btn-wrap">
                      <button className="button" onClick={() => this.searchAssets()}>
                        Apply</button>
                      <button className="button purple-outline" 
                      onClick={() => this.explorrerCollectionClose(2)}> Cancel </button>
                    </div>
                  </div>
                </div>
              </Scrollbars> 
            </div>
            <div className="filter-list-box-wrap d-inline-block">
            {!this.state.loader ? (
              this.state.exploreArray?.length > 0  ?
              <ul className="explore-nfts">
                {this.state.exploreArray?.map((explores, index) => (
                  <li key={index}>
                    <a
                      href="javascript: void(0)"
                      className="card"
                      onClick={() =>
                        this.redirectCollection(explores.collection_id, 1)
                      }
                    >
                      <div className="card-img" >
                        <img
                          src={
                            explores.collection_image
                              ? explores.collection_image
                              : "../images/card1.png"
                          }
                          alt="discover"
                        />
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={
                                  explores.user_profile_image
                                    ? explores.user_profile_image
                                    : "../images/default_image.png"
                                }
                                alt="artist block"
                              />
                            </div>
                            <div className="media-body">
                              <h4>{explores.collection_name} <img src="../images/verify.png" alt="Verify" /></h4>
                              {/* <span title={explores.collection_name}>
                                <label style={{ width: 120 + "px", whiteSpace: "nowrap", overflow: " hidden", textOverflow: "ellipsis", }} >
                                  {explores.collection_name}
                                </label>
                              </span> */}
                            </div>
                            {/* <div className="bid-count">
                              {index + 1} of{" "}
                              {this.state.exploreArray.totalRecords}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
                {/* LI END */}
              </ul>
               :
               <>
                 <div className="no-items"> 
                   <span>No Collections</span>
                 </div>
               </>
              ) :  [1, 2, 3, 4,5,6,7,8,9,10,11,12].map(loading =>(
                    <>
                      <div className="skeleton-items" key={loading}>
                      <SkeletonProduct />
                      </div>
                    </>
                  ))}
                   {/* {this.state.SkelatonLoader ? 
                          [1, 2, 3, 4, 5, 6, 7, 8].map((loading) => (
                            <>
                              <div className="skeleton-items" key={loading}>
                                <SkeletonProduct />
                              </div>
                            </>
                          ))
                          : ''
                    }
                     */}
              <div id="divmove"></div>
            </div> 
              <div className="button-wrap" style={{
                display:
                  this.pageNumber >= 2 || this.state.exploreArray.length == 0
                    ? "none"
                    : "flex",
              }} >
                <a id="skel"
                  className="button purple-outline"
                  onClick={() => this.showMore()}
                >
                  Show More
                </a>
              </div> 
          </div>
        </div>
        <section className="featured-nft" id="skelview">
          <div className="container">
            <div className="section-title">
              <h2>Featured NFTs</h2>
            </div>
            {!this.state.loader1 ? (
            <ul className="nft-list">
              {this.state.featureNftArray
                .slice(0, 3)
                .map((featureNftCollection) => (
                  <li>
                    <div className="img-group">
                      <div className="left-img">
                        {featureNftCollection.assets
                          .slice(0, 1)
                          .map((featureNftImg, i) => (
                            <a
                              // href={
                              //   "NftDetails/?assetId=" + featureNftImg.asset_id
                              // }
                              onClick={() =>
                                this.redirectCollection(
                                  featureNftImg.asset_id,
                                  2
                                )
                              }
                            >
                              <img src={featureNftImg.image_loc} alt="Img" />
                            </a>
                          ))}
                      </div>
                      <ul className="right-img">
                        {featureNftCollection.assets
                          .slice(1, 4)
                          .map((featureNftImg, i) => (
                            <li>
                              <a
                                href={
                                  "NftDetails/?assetId=" +
                                  featureNftImg.asset_id
                                }
                              >
                                <img
                                  src={featureNftImg.image_thumbnail}
                                  alt="Img"
                                />
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                    <div className="title-block">
                      <h2>{featureNftCollection.collection_name}</h2>
                      <div className="artist">
                        <div className="img-box">
                          <img
                            src={featureNftCollection.user_profile_pic}
                            alt="Artist"
                          />
                        </div>
                        <div className="name">
                          {featureNftCollection.created_by}
                        </div>
                      </div>
                      {/* <a href="/" className="button outline total-item">
                        {featureNftCollection.num_of_asset}
                      </a> */}
                    </div>
                  </li>
                ))}
            </ul>
            ) :  [1,2,3,].map(loading =>(
              <>
                <div className="skeleton-items" key={loading}>
                <SkeletonProduct />
                </div>
              </>
            ))}
          </div>
        </section>
        <Footer />
      </>
    );
  };
}
